import { parse } from 'date-fns';

export function formatRaceDistanceKm(meters) {
  if (meters == null || !Number.isFinite(Number(meters))) return '—';
  return `${(Number(meters) / 1000).toFixed(2)} km`;
}

export function formatRaceDurationSec(seconds) {
  const s = parseInt(seconds, 10);
  if (!Number.isFinite(s) || s < 0) return '—';
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  if (h > 0) return `${h}:${String(m).padStart(2, '0')}:${String(sec).padStart(2, '0')}`;
  return `${m}:${String(sec).padStart(2, '0')}`;
}

export function formatRacePaceFromSpeed(averageSpeed) {
  if (averageSpeed == null || !Number.isFinite(Number(averageSpeed)) || Number(averageSpeed) <= 0) return '—';
  const paceSec = 1000 / Number(averageSpeed);
  const min = Math.floor(paceSec / 60);
  const sec = Math.floor(paceSec % 60);
  return `${min}:${String(sec).padStart(2, '0')} /km`;
}

/**
 * Fixed-position hover card for Strava race markers (shared by ACWR + overview modals).
 */
export function RaceStripHoverCard({ race, clientX, clientY, t }) {
  if (!race || clientX == null || clientY == null) return null;

  return (
    <div
      className='fixed z-[20000] pointer-events-none rounded-lg border border-border bg-popover px-3 py-2 text-popover-foreground shadow-xl text-xs max-w-[min(320px,90vw)] space-y-1'
      style={{ left: clientX + 14, top: clientY + 10 }}
    >
      <p className='font-semibold text-sm text-foreground leading-snug'>{race.name || t('activityDetail.runType.race')}</p>
      <p className='text-muted-foreground'>
        {parse(String(race.date).slice(0, 10), 'yyyy-MM-dd', new Date()).toLocaleDateString(undefined, {
          weekday: 'short',
          month: 'short',
          day: 'numeric',
          year: 'numeric',
        })}
      </p>
      <p><span className='text-muted-foreground'>{t('athlete.distance')}:</span> {formatRaceDistanceKm(race.distance)}</p>
      <p><span className='text-muted-foreground'>{t('athlete.duration')}:</span> {formatRaceDurationSec(race.moving_time)}</p>
      <p><span className='text-muted-foreground'>{t('athlete.pace')}:</span> {formatRacePaceFromSpeed(race.average_speed)}</p>
      {race.average_watts != null && Number.isFinite(Number(race.average_watts)) && Number(race.average_watts) > 0 && (
        <p>
          <span className='text-muted-foreground'>{t('athlete.avgWatts')}:</span>{' '}
          {`${Math.round(Number(race.average_watts))} ${t('athlete.wattsUnit')}`}
        </p>
      )}
      {race.total_elevation_gain != null && Number.isFinite(Number(race.total_elevation_gain)) && (
        <p>
          <span className='text-muted-foreground'>{t('athlete.elevation')}:</span>{' '}
          {`${Math.round(Number(race.total_elevation_gain))} m`}
        </p>
      )}
      {(race.average_heartrate != null || race.max_heartrate != null) && (
        <p>
          <span className='text-muted-foreground'>{t('athlete.heartRate')}:</span>{' '}
          {race.average_heartrate != null && Number.isFinite(Number(race.average_heartrate))
            ? `${Math.round(Number(race.average_heartrate))} bpm`
            : '—'}
          {race.max_heartrate != null && Number.isFinite(Number(race.max_heartrate))
            ? ` (${Math.round(Number(race.max_heartrate))} max)`
            : ''}
        </p>
      )}
    </div>
  );
}
